import React from "react";
import styles from "./styles.module.scss";

export const PrivacyNotice = () => {
  return (
    <div className={styles.privacyNotice}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 12L15.09 8.91L12 5.82L8.91 8.91L12 12Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 22L15.09 18.91L12 15.82L8.91 18.91L12 22Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className={styles.text}>
          <p>Your data is kept safe and private</p>
          <span>
            We use enterprise-level data protection and never share your
            information
          </span>
        </div>
      </div>
    </div>
  );
};

export default PrivacyNotice;
